import { AuthService } from "./../../shared/models/auth.service";
import { WeGoConfig, IAPIResponse } from "./../../shared/config";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { TermsConditionActivityLog } from '../models/terms-condition.model';
import { TNCAcceptanceMoment } from "../../shared/models/enum-helper";

@Injectable()
export class TermsConditionPopup {

    constructor(private authService: AuthService, private http: Http) { }

    public GetTermsAndConditionsByIntanceHashId(instanceHashID: string): Observable<IAPIResponse> {
        let getTermsConditionDetail = WeGoConfig.API_GET_TERMSANDCONDITION_BYINSTANCEHASH + "?instanceHashId=" + instanceHashID;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getTermsConditionDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetTermsAndConditionsByActivationCode(activationCode: string): Observable<IAPIResponse> {
        let getTermsConditionDetail = WeGoConfig.API_GET_TERMSANDCONDITION_BYACTIVATIONCODE + "?activationCode=" + activationCode;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getTermsConditionDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetPrivacyStatementsByActivationCode(activationCode: string): Observable<IAPIResponse> {
        let getTermsConditionDetail = WeGoConfig.API_GET_PRIVACYSTATEMENT_BYACTIVATIONCODE + "?activationCode=" + activationCode;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getTermsConditionDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetTermsAndConditionsByPersonActivationCode(personActivationCode: string): Observable<IAPIResponse> {
        let getTermsConditionDetail = WeGoConfig.API_GET_TERMSANDCONDITION_BYPERSONACTIVATIONCODE + "?personActivationCode=" + personActivationCode;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getTermsConditionDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetPrivacyByPersonActivationCode(personActivationCode: string): Observable<IAPIResponse> {
        let getTermsConditionDetail = WeGoConfig.API_GET_PRIVACYSTATEMENT_BYPERSONACTIVATIONCODE + "?personActivationCode=" + personActivationCode;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getTermsConditionDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetTermsAndConditionsBySignupFormParam(signupFormParam: string): Observable<IAPIResponse> {
        let getTermsConditionDetail = WeGoConfig.API_GET_TERMSANDCONDITION_BYSIGNUPPARAM + "?signupFormParam=" + signupFormParam + "&type=T&C";
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getTermsConditionDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public UpdateTermsAndConditionsActivityLog(model: TermsConditionActivityLog): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.post(WeGoConfig.API_POST_TERMSANDCONDITION_ACTIVITYLOG, model, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ActionOnAccountActivationTermsCondition(
        tncHashId: string,
        action: number,
        bookingHashId: string = '',
        ctgHashId: string = '',
        acceptanceMoment: number[] = [TNCAcceptanceMoment.ACCOUNT_ACTIVATION]
    ): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();

        let queryString = '';
        acceptanceMoment.forEach(element => {
            queryString += "&acceptanceMoment=" + element;
        })

        let getUrl =
            WeGoConfig.API_GET_ACTION_ON_ACCOUNT_ACTIVATION_TERMS_CONDITION +
            '?' + 'tncHashId=' +
            tncHashId +
            '&action=' +
            action +
            '&bookingHashId=' +
            bookingHashId +
            '&ctgHashId=' +
            ctgHashId
            ;

        getUrl = getUrl + queryString;

        const options = new RequestOptions({ headers: headers });
        return this.http
            .get(getUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetTermsAndConditionsActivityByHashId(termsAndConditionsActivityHashId: string): Observable<IAPIResponse> {
        let getUrl = WeGoConfig.API_GET_TERMSANDCONDITIONS_ACTIVITY_BY_HASH + "?termsAndConditionActivityHashId=" + termsAndConditionsActivityHashId;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public RevokeTermsAndConditions(termsAndConditionsActivityHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http
            .post(WeGoConfig.API_POST_REVOKE_TERMSANDCONDITIONS + "?termsAndConditionsActivityHashId= " + termsAndConditionsActivityHashId, "", options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetTermsConditionForDriver(acceptanceMoment: TNCAcceptanceMoment[], bookingHashId: string = '', ctgHashId: string = ''): Observable<IAPIResponse> {
        let getTermsConditionDetail = WeGoConfig.API_GET_TERMSANDCONDITION_FOR_DRIVER + "?" + "bookingHashId=" + bookingHashId + "&ctgHashId=" + ctgHashId;

        let queryString = '';
        acceptanceMoment.forEach(element => {
            queryString += "&acceptanceMoment=" + element;
        })

        getTermsConditionDetail = getTermsConditionDetail + queryString;

        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getTermsConditionDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsconditionpopup/models/terms-condition-popup.service.ts